function link(el, binding, vnode) {
  el.addEventListener('click', function(e) {
    e.preventDefault();
    if(vnode.context && binding.value) {
      vnode.context.$router.push(binding.value)
    }
  })
}

const install = function(Vue) {
  Vue.directive('to', link)
};

export default install;



// WEBPACK FOOTER //
// ./src/common/directive.js